<template>
    <div>
        <div class="comapnyPost">
            <div class="employSearch">
                <el-input v-model="search_key_word" placeholder="请输入单位、岗位或专业名称 进行搜索"></el-input>
                <el-button type="primary" @click="getSearchList">搜索</el-button>
            </div>
            <div class="employerList">
                <el-table :data="employerList">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="detail-card">
                                <!-- 资质要求徽章行 -->
                                <div class="detail-requirements">
                                    <div class="req-badge">
                                        <span class="req-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                                            </svg>
                                        </span>
                                        <div class="req-content">
                                            <div class="req-label">年龄要求</div>
                                            <div class="req-value">{{ props.row.ageRequirements || '不限' }}</div>
                                        </div>
                                    </div>
                                    <div class="req-badge">
                                        <span class="req-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M12 14l9-5-9-5-9 5 9 5z"/><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
                                            </svg>
                                        </span>
                                        <div class="req-content">
                                            <div class="req-label">学历要求</div>
                                            <div class="req-value">{{ (!props.row.educationalRequirements || props.row.educationalRequirements === '不限') ? '不限' : props.row.educationalRequirements + '及以上' }}{{ props.row.allowTechnicianClassRelax == 1 ? '（含技工院校技师（预备技师）班毕业生）' : '' }}</div>
                                        </div>
                                    </div>
                                    <div class="req-badge">
                                        <span class="req-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
                                            </svg>
                                        </span>
                                        <div class="req-content">
                                            <div class="req-label">学位要求</div>
                                            <div class="req-value">{{ (!props.row.academicDegree || props.row.academicDegree === '无') ? '无' : props.row.academicDegree + '及以上' }}</div>
                                        </div>
                                    </div>
                                    <div class="req-badge">
                                        <span class="req-icon">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M12 15a6 6 0 100-12 6 6 0 000 12zM8.21 13.89L7 23l5-3 5 3-1.21-9.12"/>
                                            </svg>
                                        </span>
                                        <div class="req-content">
                                            <div class="req-label">职称要求</div>
                                            <div class="req-value">{{ (!props.row.professionalTitleRequirements || props.row.professionalTitleRequirements === '无') ? '无' : props.row.professionalTitleRequirements + '及以上' }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 分割线 -->
                                <div class="detail-divider"></div>

                                <!-- 详细信息列表 -->
                                <div class="detail-info-list">
                                    <div class="detail-info-row" v-if="props.row.professionalName">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                                            </svg>
                                            专业名称
                                        </span>
                                        <span class="detail-info-value">{{ props.row.professionalName }}</span>
                                    </div>
                                    <div class="detail-info-row" v-if="props.row.professionalRequirements">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                                            </svg>
                                            研究生专业要求
                                        </span>
                                        <span class="detail-info-value">{{ props.row.professionalRequirements }}</span>
                                    </div>
                                    <div class="detail-info-row" v-if="props.row.jobDescription">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                            </svg>
                                            岗位描述
                                        </span>
                                        <span class="detail-info-value">{{ props.row.jobDescription }}</span>
                                    </div>
                                    <div class="detail-info-row" v-if="props.row.otherRequirements">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 17h.01"/>
                                            </svg>
                                            岗位其他要求
                                        </span>
                                        <span class="detail-info-value">{{ props.row.otherRequirements }}</span>
                                    </div>
                                    <div class="detail-info-row" v-if="props.row.remark">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                            </svg>
                                            备注
                                        </span>
                                        <span class="detail-info-value">{{ props.row.remark }}</span>
                                    </div>
                                    <div class="detail-info-row" v-if="props.row.contactInfo">
                                        <span class="detail-info-label">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                            </svg>
                                            联系电话
                                        </span>
                                        <span class="detail-info-value">{{ props.row.contactInfo }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="岗位代码" min-width="70" align="center" prop="nameOfSuperiorUnit">
                    </el-table-column>
                    <el-table-column label="单位名称" min-width="100" align="center" prop="nameOfEmployer">
                    </el-table-column>
                    <el-table-column label="专业名称" min-width="400" align="center" prop="professionalName">
                    </el-table-column>
                    <el-table-column label="岗位类别" min-width="80" align="center" prop="jobCategory">
                    </el-table-column>
                    <el-table-column label="招聘人数" min-width="60"  align="center" prop="recruitingNum">
                    </el-table-column>
                    <el-table-column fixed="right" min-width="80" align="center" label="操作" >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.state !== '0'" @click="deliver(scope.row)" type="text" size="small">立即报名</el-button>
                            <span v-else class="closed-tag">报名已截止</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <applyJobDialog ref="apply_dialog_ref"></applyJobDialog>
    </div>
</template>
<script>
import { getTalentIntroductionPositions, getRegistrationList, getMyRegistrationInfo } from "@/api/index.js";
import applyJobDialog from './dialog_apply_job.vue'
export default {
    components:{
        applyJobDialog,
    },
    props: {
        talentIntroductionId: { type: String, default: '' },
    },
    data() {
        return {
            search_key_word: '', //岗位搜索关键词
            employerList: []

        }
    },
    mounted() {
        this.getSearchList();

    },
    methods: {
        //搜索查询列表
        getSearchList() {
            getTalentIntroductionPositions({
                searchValue: this.search_key_word,
                talentIntroductionId: this.talentIntroductionId,
            }).then(res => {
                this.employerList = res.rows
            })
        },

        //申请提交弹框
        deliver(item){
            // 获取用户信息，判断是否登录
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

            // 判断用户是否登录（通过phone是否有值判断）
            if (!userInfo.phone) {
                // 未登录，跳转到登录页，登录后返回本页（报名通道标签）
                this.$router.push({
                    path: '/login',
                    query: { redirect: '/joinUs?id=' + this.talentIntroductionId + '&sub=3' }
                })
                return
            }

            // 已登录，调用getRegistrationList方法查看用户是否已报过名
            getRegistrationList({
              talentIntroductionId: this.talentIntroductionId,
            }).then(res => {
                if (!res.data || !res.data.id) {
                    // 没报过名，可以继续报名
                    let copy_data = JSON.parse(JSON.stringify(item))
                    this.$refs.apply_dialog_ref.openInit(copy_data)
                } else if (res.data.status === 0) {
                    // 报名状态为0（审核不通过），获取之前的报名信息并填充到表单
                    getMyRegistrationInfo({talentIntroductionId: this.talentIntroductionId}).then(infoRes => {
                        let copy_data = JSON.parse(JSON.stringify(item))
                        // 将之前的报名信息和当前岗位信息一起传递给报名表单组件
                        this.$refs.apply_dialog_ref.openInit(copy_data, infoRes.data)
                    }).catch(err => {
                        // 获取失败时，仍然打开空表单
                        let copy_data = JSON.parse(JSON.stringify(item))
                        this.$refs.apply_dialog_ref.openInit(copy_data)
                    })
                } else {
                    // 已报名且状态不为0，提示用户不能报名
                    let statusText = ''
                    if (res.data.status === 1) {
                        statusText = '审核中'
                    } else if (res.data.status === 2) {
                        statusText = '审核通过'
                    }
                    this.$message({
                        message: `您已提交过报名申请，当前状态为${statusText}，不能重复报名`,
                        type: 'warning'
                    })
                }
            }).catch(err => {
                this.$message.error('获取报名记录失败，请稍后再试')
            })
        },


    }

}

</script>
<style lang="scss" scoped>
.comapnyPost {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 32px;

    .employSearch {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        gap: 12px;

        .el-input {
            width: 560px;
        }

        .el-input__inner {
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            border: 1.5px solid #BAE6FD;
            border-radius: 8px;
            color: #1E293B;
            background: #F8FAFC;
            transition: border-color 0.2s, box-shadow 0.2s;

            &:focus {
                border-color: #0369A1;
                box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
                background: #fff;
            }
        }

        .el-button--primary {
            background: linear-gradient(135deg, #0369A1, #0EA5E9);
            color: #fff;
            height: 44px;
            min-width: 100px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 1px;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            transition: opacity 0.2s, transform 0.15s;
            box-shadow: 0 2px 8px rgba(3, 105, 161, 0.3);

            &:hover {
                opacity: 0.9;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(3, 105, 161, 0.4);
            }
            &:active { transform: translateY(0); }
        }
    }

    .employerList {
        .expandEmploy {
            clear: both;
            margin-bottom: 15px;
            overflow: hidden;

            span {
                font-weight: 600;
                display: block;
                float: left;
                width: 110px;
                text-align: right;
                line-height: 30px;
            }

            label {
                display: block;
                float: left;
                white-space: pre-wrap;
                line-height: 30px;
                letter-spacing: 1px;
                width: 700px;
            }
        }
    }

    .detail-card {
        padding: 20px 24px;

        .detail-requirements {
            display: flex;
            gap: 14px;
            flex-wrap: wrap;

            .req-badge {
                display: flex;
                align-items: center;
                gap: 12px;
                background: linear-gradient(135deg, #EFF6FF 0%, #F0F9FF 100%);
                border: 1px solid #BAE6FD;
                border-radius: 10px;
                padding: 12px 16px;
                min-width: 155px;
                flex: 1;
                box-shadow: 0 1px 4px rgba(3, 105, 161, 0.06);
                transition: box-shadow 0.2s, transform 0.2s;

                &:hover {
                    box-shadow: 0 4px 12px rgba(3, 105, 161, 0.14);
                    transform: translateY(-1px);
                }

                .req-icon {
                    width: 36px;
                    height: 36px;
                    background: linear-gradient(135deg, #0369A1, #0EA5E9);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    box-shadow: 0 2px 6px rgba(3, 105, 161, 0.3);

                    svg {
                        width: 18px;
                        height: 18px;
                        stroke: #fff;
                    }
                }

                .req-content {
                    .req-label {
                        font-size: 11px;
                        color: #64748B;
                        letter-spacing: 0.4px;
                        margin-bottom: 3px;
                        font-weight: 500;
                    }

                    .req-value {
                        font-size: 14px;
                        font-weight: 700;
                        color: #0C4A6E;
                        line-height: 1.3;
                    }
                }
            }
        }

        .detail-divider {
            height: 1px;
            background: linear-gradient(90deg, transparent, #BAE6FD 30%, #BAE6FD 70%, transparent);
            margin: 18px 0;
        }

        .detail-info-list {
            display: flex;
            flex-direction: column;
            gap: 4px;

            .detail-info-row {
                display: flex;
                align-items: flex-start;
                gap: 0;
                padding: 8px 12px;
                border-radius: 8px;
                transition: background 0.15s;
                cursor: default;

                &:hover {
                    background: #F0F9FF;
                }

                &--remark {
                    background: #FFFBEB;
                    border: 1px solid #FEF08A;
                    border-radius: 8px;

                    &:hover {
                        background: #FEF9C3;
                    }

                    .detail-info-label {
                        color: #92400E;

                        svg { stroke: #D97706; }
                    }

                    .detail-info-value--remark {
                        color: #78350F;
                        font-style: italic;
                    }
                }

                .detail-info-label {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #0369A1;
                    min-width: 140px;
                    flex-shrink: 0;
                    line-height: 1.6;

                    svg {
                        width: 14px;
                        height: 14px;
                        stroke: #0EA5E9;
                        flex-shrink: 0;
                    }
                }

                .detail-info-value {
                    font-size: 13px;
                    color: #334155;
                    line-height: 1.65;
                    flex: 1;
                }
            }
        }
    }
}

:deep(.el-table) {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #E0F2FE;

    th.el-table__cell {
        background: #F0F9FF !important;
        color: #0C4A6E;
        font-weight: 600;
        font-size: 13px;
        letter-spacing: 0.3px;
        border-bottom: 2px solid #BAE6FD !important;
    }

    .el-table__row:hover > td {
        background: #F0F9FF !important;
    }

    .el-button--text {
        color: #0369A1;
        font-weight: 600;
        font-size: 13px;
        padding: 6px 12px;
        border-radius: 6px;
        transition: background 0.15s;

        &:hover {
            background: #E0F2FE;
            color: #0284C7;
        }
    }
}

.closed-tag {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    color: #94A3B8;
    background: #F1F5F9;
    border: 1px solid #E2E8F0;
    letter-spacing: 0.5px;
}

:deep(.el-table__expanded-cell) {
    background: linear-gradient(180deg, #F8FBFF 0%, #FAFCFF 100%) !important;
    padding: 12px 24px 12px 60px !important;
    border-bottom: 2px solid #BFDBFE !important;
    border-top: 1px solid #E0F2FE !important;
}
</style>
